module.exports = __webpack_public_path__ + "static/img/09_pro.2f25c94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/09_pro.jpg
// module id = YX3U
// module chunks = 0